/* NATTY GARB (Mono base) — interactions */
(function(){
  'use strict';
  var money = (window.Shopify && Shopify.formatMoney) ? null : null;

  /* ----------------------------------------------------------------
     Mobile header drawer
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-site-header]').forEach(function(header){
    var toggle = header.querySelector('[data-mobile-menu-toggle]');
    if(!toggle) return;
    function setOpen(open){
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
    toggle.addEventListener('click', function(){ setOpen(!header.classList.contains('is-open')); });
    header.querySelectorAll('a').forEach(function(link){ link.addEventListener('click', function(){ setOpen(false); }); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setOpen(false); });
  });

  /* ----------------------------------------------------------------
     Collection sort dropdown
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-sort-select]').forEach(function(select){
    select.addEventListener('change', function(){ if(select.form) select.form.submit(); });
  });

  /* ----------------------------------------------------------------
     Variant picker on product page
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function(root){
    var data = root.querySelector('[data-variants-json]');
    if(!data) return;
    var variants = [];
    try { variants = JSON.parse(data.textContent || '[]'); } catch(e){ return; }
    var idSelect = root.querySelector('select[name="id"]');
    var priceEl  = root.querySelector('[data-price]');
    var addBtn   = root.querySelector('[data-add]');
    function selectedOptions(){
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function(group){
        var on = group.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function update(){
      var sel = selectedOptions();
      var match = variants.find(function(v){ return v.options.every(function(o,i){ return o === sel[i]; }); });
      if(match){
        if(idSelect) idSelect.value = String(match.id);
        if(priceEl && match.price) priceEl.textContent = match.price;
        if(addBtn){ addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'Add to bag' : 'Sold out'; }
      } else if(addBtn){ addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
    }
    root.querySelectorAll('[data-option-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('[data-option-index]');
        if(!group) return;
        group.querySelectorAll('[data-option-btn]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed','true');
        update();
      });
    });
    update();
  });

  /* ================================================================
     CART DRAWER + AJAX
  ================================================================ */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function fmtMoney(cents){
    var amount = cents/100;
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        var cur = Shopify.currency.active;
        var locale = (cur === 'INR') ? 'en-IN' : undefined;
        var prefix = (cur === 'INR') ? 'Rs.' : '';
        return prefix + amount.toLocaleString(locale, {minimumFractionDigits:2, maximumFractionDigits:2});
      }
    } catch(e){}
    return amount.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  function setCartCounts(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
  }

  function openDrawer(){
    if(!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    var c = drawer.querySelector('.drawer__close'); if(c) c.focus();
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderDrawer(cart){
    if(!drawer) return;
    setCartCounts(cart.item_count);
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    if(!body) return;
    if(!cart.items || cart.items.length === 0){
      body.innerHTML = '<div class="drawer__empty">Your bag is empty</div>';
      if(foot) foot.hidden = true;
      return;
    }
    if(foot) foot.hidden = false;
    var html = '<ul class="drawer__items">';
    cart.items.forEach(function(item){
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="drawer__item-variant">'+item.variant_title+'</div>' : '';
      html += '<li class="drawer__item" data-line-key="'+item.key+'">'
        + '<a class="drawer__item-media" href="'+item.url+'">'+(img?'<img src="'+img+'" alt="'+(item.product_title||'')+'" loading="lazy">':'')+'</a>'
        + '<div class="drawer__item-info">'
          + '<a class="drawer__item-title" href="'+item.url+'">'+item.product_title+'</a>'
          + variant
          + '<div class="drawer__item-qty">'
            + '<button type="button" data-qty-down aria-label="Decrease quantity">&minus;</button>'
            + '<span>'+item.quantity+'</span>'
            + '<button type="button" data-qty-up aria-label="Increase quantity">+</button>'
          + '</div>'
          + '<button type="button" class="drawer__item-remove" data-remove>Remove</button>'
        + '</div>'
        + '<div class="drawer__item-price">'+fmtMoney(item.final_line_price)+'</div>'
      + '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    var sub = drawer.querySelector('[data-cart-subtotal]');
    if(sub) sub.textContent = fmtMoney(cart.total_price);
  }

  function fetchCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  }
  function refreshDrawer(){
    if(drawer) drawer.classList.add('is-loading');
    return fetchCart().then(function(cart){ renderDrawer(cart); if(drawer) drawer.classList.remove('is-loading'); return cart; });
  }
  function changeLine(key, qty){
    if(drawer) drawer.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){ return r.json(); }).then(function(cart){ renderDrawer(cart); if(drawer) drawer.classList.remove('is-loading'); return cart; });
  }

  // drawer events
  if(drawer){
    drawer.addEventListener('click', function(e){
      if(e.target.matches('[data-cart-overlay]') || e.target.matches('[data-cart-close]')){ closeDrawer(); return; }
      var row = e.target.closest('[data-line-key]');
      if(!row) return;
      var key = row.getAttribute('data-line-key');
      var qtyEl = row.querySelector('.drawer__item-qty span');
      var qty = qtyEl ? parseInt(qtyEl.textContent,10) : 1;
      if(e.target.closest('[data-qty-up]'))   changeLine(key, qty+1);
      else if(e.target.closest('[data-qty-down]')) changeLine(key, Math.max(0, qty-1));
      else if(e.target.closest('[data-remove]'))   changeLine(key, 0);
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
  }

  // header bag buttons open the drawer
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      if(!drawer) return; // fall back to navigating to /cart
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    });
  });

  /* ================================================================
     QUICK ADD (collection / featured cards)
  ================================================================ */
  function toast(msg){
    var t = document.querySelector('[data-toast]');
    if(!t){
      t = document.createElement('div');
      t.className = 'toast'; t.setAttribute('data-toast','');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>'+msg+'</span>' + (drawer ? '<a href="#" data-toast-view>View bag</a>' : '<a href="/cart">View bag</a>');
    requestAnimationFrame(function(){ t.classList.add('is-visible'); });
    clearTimeout(t._timer);
    t._timer = setTimeout(function(){ t.classList.remove('is-visible'); }, 3200);
    var view = t.querySelector('[data-toast-view]');
    if(view) view.addEventListener('click', function(e){ e.preventDefault(); t.classList.remove('is-visible'); refreshDrawer().then(openDrawer); });
  }

  function addToCart(variantId, btn){
    if(!variantId) return;
    if(btn){ btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id: variantId, quantity: 1})
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(){
      if(btn){ btn.classList.remove('is-loading'); }
      if(drawer){ refreshDrawer().then(openDrawer); }
      else { fetchCart().then(function(c){ setCartCounts(c.item_count); }); toast('Added to bag'); }
    }).catch(function(){
      if(btn){ btn.classList.remove('is-loading'); }
      toast('Could not add — try the product page');
    });
  }

  document.querySelectorAll('[data-quickadd]').forEach(function(qa){
    // toggle size strip
    var openBtn = qa.querySelector('[data-qa-open]');
    var sizes = qa.querySelector('[data-qa-sizes]');
    if(openBtn && sizes){
      openBtn.addEventListener('click', function(e){
        e.preventDefault();
        var willOpen = sizes.hasAttribute('hidden');
        if(willOpen){ sizes.removeAttribute('hidden'); } else { sizes.setAttribute('hidden',''); }
        openBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }
    // add buttons (single-variant "+" or each size)
    qa.querySelectorAll('[data-qa-add]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    });
  });

  /* ================================================================
     CAROUSEL — arrows, drag-to-scroll, progress counter
  ================================================================ */
  document.querySelectorAll('[data-carousel]').forEach(function(root){
    var vp = root.querySelector('[data-carousel-viewport]');
    var track = root.querySelector('[data-carousel-track]');
    if(!vp || !track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var bar  = root.querySelector('[data-carousel-bar]');
    var cur  = root.querySelector('[data-carousel-current]');
    var total= root.querySelector('[data-carousel-total]');

    function step(){
      var first = track.querySelector('.card');
      return first ? first.getBoundingClientRect().width : vp.clientWidth * 0.5;
    }
    function maxScroll(){ return vp.scrollWidth - vp.clientWidth; }
    function update(){
      var ms = maxScroll();
      if(prev) prev.disabled = vp.scrollLeft <= 2;
      if(next) next.disabled = vp.scrollLeft >= ms - 2;
      var ratioVisible = vp.clientWidth / vp.scrollWidth;
      if(bar){
        bar.style.width = Math.max(12, ratioVisible*100) + '%';
        var travel = ms > 0 ? (vp.scrollLeft / ms) : 0;
        bar.style.transform = 'translateX(' + (travel * (100/Math.max(ratioVisible,0.0001) - 100)) + '%)';
      }
      if(cur && total){
        var per = step();
        var count = track.querySelectorAll('.card').length;
        var perView = Math.max(1, Math.round(vp.clientWidth / per));
        var page = Math.min(count, Math.floor(vp.scrollLeft / per) + perView);
        cur.textContent = Math.max(1, Math.min(count, Math.ceil((vp.scrollLeft + vp.clientWidth) / per)));
        total.textContent = count;
      }
    }
    if(total){ total.textContent = track.querySelectorAll('.card').length; }
    if(prev) prev.addEventListener('click', function(){ vp.scrollBy({left:-step()*Math.max(1,Math.floor(vp.clientWidth/step())), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ vp.scrollBy({left: step()*Math.max(1,Math.floor(vp.clientWidth/step())), behavior:'smooth'}); });
    vp.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, {passive:true});
    window.addEventListener('resize', update);

    // drag to scroll (pointer)
    var down=false, startX=0, startLeft=0, moved=false;
    vp.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'mouse' && e.button !== 0) return;
      down=true; moved=false; startX=e.clientX; startLeft=vp.scrollLeft;
      vp.classList.add('is-dragging');
    });
    vp.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - startX;
      if(Math.abs(dx) > 4) moved=true;
      vp.scrollLeft = startLeft - dx;
    });
    function endDrag(){ if(!down) return; down=false; vp.classList.remove('is-dragging'); }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('pointerleave', endDrag);
    // prevent click navigation right after a drag
    vp.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);

    update();
  });

  /* ================================================================
     PRODUCT MEDIA — thumb scroll + active state + zoom on hover
  ================================================================ */
  document.querySelectorAll('[data-product-media]').forEach(function(mediaRoot){
    var thumbs = mediaRoot.querySelectorAll('.pdp__thumb');
    var slides = mediaRoot.querySelectorAll('.pdp__slide');

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(e){
        var targetId = thumb.getAttribute('href');
        if(!targetId || targetId.charAt(0) !== '#') return;
        var target = mediaRoot.querySelector(targetId);
        if(!target) return;
        e.preventDefault();
        target.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'});
      });
    });

    // mark active thumb based on which slide is most in view
    if('IntersectionObserver' in window && thumbs.length){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            var idx = Array.prototype.indexOf.call(slides, en.target);
            thumbs.forEach(function(t,i){ t.classList.toggle('is-active', i === idx); });
          }
        });
      }, {root: mediaRoot.querySelector('.pdp__gallery') || null, threshold:0.6});
      slides.forEach(function(s){ io.observe(s); });
    }

    // pointer-tracking zoom on each slide (image follows cursor)
    slides.forEach(function(slide){
      var img = slide.querySelector('img');
      if(!img) return;
      slide.addEventListener('mousemove', function(e){
        if(window.matchMedia('(hover:none)').matches) return;
        var r = slide.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      slide.addEventListener('mouseleave', function(){ img.style.transformOrigin = 'center center'; });
    });
  });

})();
